import { render } from "./DetailProjectFooter.vue?vue&type=template&id=9d91a756&scoped=true"
import script from "./DetailProjectFooter.vue?vue&type=script&lang=js"
export * from "./DetailProjectFooter.vue?vue&type=script&lang=js"

import "./DetailProjectFooter.vue?vue&type=style&index=0&id=9d91a756&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d91a756"]])

export default __exports__